import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";

export const fetchFileById = createAsyncThunk("files/fetchById", async (id) => {
  const response = await axiosInstance.get(`/api/files/${id}`);
  return response.data;
});

export const fetchFilesByLeadId = createAsyncThunk("files/fetchByLeadId", async (leadId) => {
  if (!leadId) return;
  const response = await axiosInstance.get(`/api/files/${leadId}`);
  return response.data;
});

export const downloadFileByIdName = createAsyncThunk("files/download", async ({ id, filename }) => {
  const response = await axiosInstance.get(`/api/files/download/${id}/${filename}`, { responseType: "blob" });
  return response.data;
});

export const uploadFileInReport = createAsyncThunk("files/upload", async (formData) => {
  const response = await axiosInstance.post("/api/files", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
});

export const deleteFileByIdName = createAsyncThunk("files/delete", async ({ leadId, fileName }) => {
  await axiosInstance.delete(`/api/files/${leadId}/${fileName}`);
  return { leadId, fileName };
});

const fileSlice = createSlice({
  name: "files",
  initialState: {
    files: [],
    selectedFile: null,
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder

    .addCase(fetchFileById.pending, (state) => { state.loading = true; })
      .addCase(fetchFileById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedFile = action.payload;
      })
      .addCase(fetchFileById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchFilesByLeadId.pending, (state) => { state.loading = true; })
      .addCase(fetchFilesByLeadId.fulfilled, (state, action) => {
        state.loading = false;
        state.files = action.payload;
      })
      .addCase(fetchFilesByLeadId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(downloadFileByIdName.pending, (state) => { state.loading = true; })
      .addCase(downloadFileByIdName.fulfilled, (state) => { state.loading = false; })
      .addCase(downloadFileByIdName.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(uploadFileInReport.pending, (state) => { state.loading = true; })
      .addCase(uploadFileInReport.fulfilled, (state, action) => {
        state.loading = false;
        state.files.push(action.payload);
      })
      .addCase(uploadFileInReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(deleteFileByIdName.pending, (state) => { state.loading = true; })
      .addCase(deleteFileByIdName.fulfilled, (state, action) => {
        state.loading = false;
        state.files = state.files.filter(file => file.fileName !== action.payload.fileName);
      })
      .addCase(deleteFileByIdName.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default fileSlice.reducer;
